<template>
  <div>
    <section>
      <b-field grouped group-multiline>
        <div class="control">
          <!-- <button class="button" @click="isCardModalActive = true">Adicionar Transação</button> -->
          <button class="button" @click="cardModal()">Adicionar Transação</button>
        </div>
      </b-field>

      <b-table
        :data="isEmpty ? [] : this.$store.getters['transacao/getTransacoes']"
        :paginated="true"
        :current-page.sync="currentPage"
        :per-page="perPage"
        :default-sort-direction="defaultSortDirection"
        default-sort="data"
        :mobile-cards="true"
      >
        <template slot-scope="props">
          <b-table-column field="id" label="ID" width="40" numeric>{{ props.index+1 }}</b-table-column>

          <b-table-column field="descricao" label="Descrição">{{ props.row.descricao }}</b-table-column>

          <b-table-column field="tipo" label="Tipo" width="50" sortable centered>
            <span
              class="tag"
              :class="[props.row.valor > 0 ? 'is-success' : 'is-danger']"
            >{{ props.row.tipo }}</span>
          </b-table-column>

          <b-table-column
            field="data"
            label="Data"
            width="50"
            sortable
            centered
          >{{ new Date(props.row.data.seconds*1000).toLocaleDateString() }}</b-table-column>

          <b-table-column field="valor" label="Valor" width="50" sortable centered>
            <span
              class="tag"
              :class="[props.row.valor > 0 ? 'is-success' : 'is-danger']"
            >R$ {{ props.row.valor }}</span>
          </b-table-column>

          <b-table-column label="Gerenciar" centered>
            <div class="control">
              <center>
                <a class="cop-bt cop-bt-success" @click="openEditTransacao(props.row)">
                  <i class="fas fa-pen"></i>
                </a>
                <a class="cop-bt cop-bt-danger" @click="deleteTransacao(props.row)">
                  <i v-if="props.row.allowedErase" class="fas fa-trash"></i>
                  <i v-else class="fas fa-info"></i>
                </a>
              </center>
            </div>
          </b-table-column>
        </template>

        <template slot="empty">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon icon="emoticon-sad" size="is-large"></b-icon>
              </p>
              <p>Não há dados para serem exibidos.</p>
            </div>
          </section>
        </template>
      </b-table>
    </section>
  </div>
</template>

<script>
import AddTransacao from "./components/AddTransacao";
import EditTransacao from "./components/EditTransacao";

export default {
  data() {
    return {
      isEmpty: false,
      defaultSortDirection: "desc",
      currentPage: 1,
      perPage: 15,
    };
  },

  computed: {
    successDeleteTransacao() {
      return this.$store.getters["transacao/getIsSuccess"];
    }
  },

  methods: {
    deleteTransacao(transacao) {
      if (transacao.allowedErase) {
        this.$dialog.confirm({
          title: "Apagar Transação?",
          message: `Clique em 'Ok' para apagar a transação: ${transacao.descricao}
            no valor de R$ ${transacao.valor}`,
            onConfirm: async () => {
              const loadingComponent = this.$loading.open({
                container: null
              });
              await this.$store.dispatch("transacao/deleteTransacaoInFirestore", transacao);
              loadingComponent.close();

              if (this.successDeleteTransacao) {
                this.$store.dispatch("transacao/getTransacoesInFirestore");
                this.$alert("Sucesso!", "Transação Removida!", "success");
                this.$store.commit("transacao/setIsSuccess", false);
              } else {
                this.$alert("Erro!", "Erro ao Remover Transação!", "danger");
              }
            }
        });
      } else {
        this.$dialog.alert({
          title: 'Informação',
          message: `Mensalidades dos associados devem ser excluidas
            na aba 'Associado>Mensalidades' a partir do menu.`,
          confirmText: 'Entendido!'
        });
      }
    },

    cardModal() {
      this.$modal.open({
        parent: this,
        component: AddTransacao,
        hasModalCard: true
      });
    },

    openEditTransacao(transacao) {
      this.$modal.open({
        parent: this,
        component: EditTransacao,
        hasModalCard: true,
        props: {
          oldTransacao: transacao
        }
      });
    },
  },
  mounted() {
    // Tentar adicionar essas requisições no App.js, para ver se as consultas ao banco são otimizadas
    this.$store.dispatch("transacao/getTransacoesInFirestore");
    this.$store.dispatch("contas/getContasInFirestore");
    this.$store.dispatch("associacao/getAssociacaoInFirestore");
  }
};
</script>

<style scoped>
.cop-bt {
  margin: 0 10px;
}
.cop-bt-success {
  color: rgb(81, 139, 247);
}
.cop-bt-success:hover {
  color: rgb(17, 67, 158);
  font-size: 1.1rem;
}
.cop-bt-danger {
  color: #ce7676;
}
.cop-bt-danger:hover {
  color: red;
  font-size: 1.1rem;
}
</style>

